@if(!activeUrl.includes('display-pdf/')){
<div>
  <app-navbar></app-navbar>
</div>
}

<router-outlet />
@if(!activeUrl.includes('display-pdf/')){
<div>
  <app-footer></app-footer>
</div>
<a href="https://www.eg-insurtech.com/" class="eg-logo" target="_blank">
  <img src="assets/images/eg-logo.png" alt="eg insurtech logo logo" />
</a>
}

